import { createContext, useContext } from 'react';

export const defaultOrderDetailsNavigationContext = Object.freeze({
  previousSalesOrderId: undefined,
  previousFulfillmentPlanId: undefined,
  nextSalesOrderId: undefined,
  nextFulfillmentPlanId: undefined,
});

export const OrderDetailsNavigationContext = createContext(defaultOrderDetailsNavigationContext);

export const useOrderDetailsNavigationContext = () => useContext(OrderDetailsNavigationContext);
